import React from 'react'
import "./table1.css"
export default function table1() {
  return (
    <>
    <h3 className="d-card-title">Historical Events</h3>
    <div><table className='table1'>
    <tr>
      <th>Events</th>
      <th>Date</th>
    </tr>
    <tr>
      <td>SPOCC'2022</td>
      <td>22nd September 2022</td>
      </tr>
      <tr> <td>HACKOVERFLOW 2022</td> <td>September 17, 2022</td></tr>
      <tr><td>GRAPHICON 2022</td><td>September 18,2022</td></tr>
      <tr> <td>CLOUDSPLORE 2022</td><td>OCTOBER 3, 2021</td></tr>
      <tr> <td>CLOUDSPLORE 2021</td><td>October 7, 2021.</td></tr>
      <tr><td>SPOCC’21</td><td>September 20, 2020</td></tr>
      <tr><td>SPOCC’20</td><td>28TH FEB TO 1ST MARCH 2020</td></tr>
     <tr><td>CLOUDSPLORE 2021</td><td>22ND TO 23RD OCTOBER 2019</td></tr>
     <tr> <td>ERUDITION’20</td><td>28TH FEB TO 1ST MARCH 2020</td></tr>
     <tr><td>QUIZARD</td> <td>22ND TO 23RD OCTOBER 2019</td></tr>
     <tr><td>WORKSHOP ON FLUTTER & FIREBASE</td><td>5TH MARCH TO 9TH MARCH 2019</td></tr>
     <tr>  <td>Workshop on Amazon Web Services with Alexa</td> <td>12th April to 15th April 2018</td></tr>
     <tr><td>Workshop on Cloud Essentials & Linux</td><td>9th to 11th November 2017.</td></tr>
  </table></div>
  </>
  )
}
